import { createTheme } from '@mui/material/styles';

// 1. Corporate Gray - 기업용 회색 톤 (가장 보수적)
export const corporateGrayTheme = {
  light: createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: '#2C3E50',  // 다크 그레이-블루
        light: '#34495E',
        dark: '#1B2631',
      },
      secondary: {
        main: '#3498DB',  // 클린 블루
        light: '#5DADE2',
        dark: '#2980B9',
      },
      success: {
        main: '#1E8449',
        light: '#27AE60',
        dark: '#166337',
      },
      error: {
        main: '#E74C3C',
        light: '#EC7063',
        dark: '#CB4335',
      },
      warning: {
        main: '#F39C12',
        light: '#F8C471',
        dark: '#E67E22',
      },
      info: {
        main: '#3498DB',
        light: '#5DADE2',
        dark: '#2980B9',
      },
      background: {
        default: '#FAFAFA',
        paper: '#FFFFFF',
      },
      text: {
        primary: '#2C3E50',
        secondary: '#7F8C8D',
      },
    },
  }),
  dark: createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#91AAC2',
        light: '#B2C3D4',
        dark: '#34495E',
      },
      secondary: {
        main: '#5DADE2',
        light: '#85C1E9',
        dark: '#3498DB',
      },
      success: {
        main: '#2ECC71',
        light: '#58D68D',
        dark: '#27AE60',
      },
      error: {
        main: '#EC7063',
        light: '#F1948A',
        dark: '#E74C3C',
      },
      warning: {
        main: '#F8C471',
        light: '#FDEAA7',
        dark: '#F39C12',
      },
      info: {
        main: '#5DADE2',
        light: '#85C1E9',
        dark: '#3498DB',
      },
      background: {
        default: '#1B2631',
        paper: '#2C3E50',
      },
      text: {
        primary: '#FFFFFF',
        secondary: '#BDC3C7',
      },
    },
  }),
  name: 'Corporate Gray',
  description: '기업용 회색 톤 - 가장 보수적이고 안전한 선택',
  chartColors: ['#2C3E50', '#34495E', '#5D6D7E', '#85929E', '#AEB6BF', '#D5DBDB', '#3498DB', '#5DADE2'],
};

// 2. Financial Navy - 전통적인 금융 네이비
export const financialNavyTheme = {
  light: createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: '#1B2951',  // 진한 네이비
        light: '#2C5AA0',
        dark: '#0D1421',
      },
      secondary: {
        main: '#3A7BD5',  // 로열 블루
        light: '#6FA8DC',
        dark: '#2E5A87',
      },
      success: {
        main: '#007D6F',
        light: '#00A693',
        dark: '#00544B',
      },
      error: {
        main: '#D73502',
        light: '#FF6B47',
        dark: '#B02A01',
      },
      warning: {
        main: '#FF8A00',
        light: '#FFAB47',
        dark: '#CC6E00',
      },
      info: {
        main: '#3A7BD5',
        light: '#6FA8DC',
        dark: '#2E5A87',
      },
      background: {
        default: '#F8F9FC',
        paper: '#FFFFFF',
      },
      text: {
        primary: '#1B2951',
        secondary: '#4A5568',
      },
    },
  }),
  dark: createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#6094DD',
        light: '#8AB0E6',
        dark: '#3A7BD5',
        contrastText: '#000000',  // 밝은 primary 위 글자 대비 4.5:1 확보 (AppBar/contained 버튼)
      },
      secondary: {
        main: '#26D0CE',
        light: '#4DD0E1',
        dark: '#00A693',
      },
      success: {
        main: '#26D0CE',
        light: '#4DD0E1',
        dark: '#00A693',
      },
      error: {
        main: '#FF6B47',
        light: '#FF8A65',
        dark: '#D73502',
      },
      warning: {
        main: '#FFAB47',
        light: '#FFC107',
        dark: '#FF8A00',
      },
      info: {
        main: '#6FA8DC',
        light: '#90CAF9',
        dark: '#3A7BD5',
      },
      background: {
        default: '#0D1421',
        paper: '#1B2951',
      },
      text: {
        primary: '#FFFFFF',
        secondary: '#B0BEC5',
      },
    },
  }),
  name: 'Financial Navy',
  description: '전통적인 금융 네이비 - 은행과 증권사에서 선호하는 신뢰감 있는 색상',
  chartColors: ['#1B2951', '#2C5AA0', '#3A7BD5', '#6FA8DC', '#90CAF9', '#BBDEFB', '#00A693', '#26D0CE'],
};

// 3. Minimal Neutral - 극도로 절제된 뉴트럴
export const minimalNeutralTheme = {
  light: createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: '#4A5568',  // 미디움 그레이
        light: '#718096',
        dark: '#2D3748',
      },
      secondary: {
        main: '#718096',  // 라이트 그레이
        light: '#A0AEC0',
        dark: '#4A5568',
      },
      success: {
        main: '#268149',
        light: '#68D391',
        dark: '#1D6137',
      },
      error: {
        main: '#E40505',
        light: '#FC8181',
        dark: '#BC0404',
      },
      warning: {
        main: '#F6AD55',
        light: '#FBD38D',
        dark: '#ED8936',
      },
      info: {
        main: '#63B3ED',
        light: '#90CDF4',
        dark: '#4299E1',
      },
      background: {
        default: '#FFFFFF',
        paper: '#FAFAFA',
      },
      text: {
        primary: '#1A202C',
        secondary: '#718096',
      },
    },
  }),
  dark: createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#97A2B2',
        light: '#B4BCC8',
        dark: '#718096',
      },
      secondary: {
        main: '#A0AEC0',
        light: '#CBD5E0',
        dark: '#718096',
      },
      success: {
        main: '#9AE6B4',
        light: '#C6F6D5',
        dark: '#68D391',
      },
      error: {
        main: '#FEB2B2',
        light: '#FED7D7',
        dark: '#FC8181',
      },
      warning: {
        main: '#FBD38D',
        light: '#FEEBC8',
        dark: '#F6AD55',
      },
      info: {
        main: '#90CDF4',
        light: '#BEE3F8',
        dark: '#63B3ED',
      },
      background: {
        default: '#1A202C',
        paper: '#2D3748',
      },
      text: {
        primary: '#F7FAFC',
        secondary: '#CBD5E0',
      },
    },
  }),
  name: 'Minimal Neutral',
  description: '극도로 절제된 뉴트럴 - 현대적이고 미니멀한 접근',
  chartColors: ['#4A5568', '#718096', '#A0AEC0', '#CBD5E0', '#E2E8F0', '#F7FAFC', '#63B3ED', '#90CDF4'],
};

// 4. Warm Professional - 따뜻한 전문가 톤
export const warmProfessionalTheme = {
  light: createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: '#553C9A',  // 딥 퍼플
        light: '#805AD5',
        dark: '#44337A',
      },
      secondary: {
        main: '#667EEA',  // 소프트 블루-퍼플
        light: '#9F7AEA',
        dark: '#5A67D8',
      },
      success: {
        main: '#2C7F53',
        light: '#38A169',
        dark: '#22613F',
      },
      error: {
        main: '#E53E3E',
        light: '#FC8181',
        dark: '#C53030',
      },
      warning: {
        main: '#DD6B20',
        light: '#F6AD55',
        dark: '#C05621',
      },
      info: {
        main: '#3182CE',
        light: '#63B3ED',
        dark: '#2C5282',
      },
      background: {
        default: '#F7FAFC',
        paper: '#FFFFFF',
      },
      text: {
        primary: '#2D3748',
        secondary: '#4A5568',
      },
    },
  }),
  dark: createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#AC93E3',
        light: '#CBBBEE',
        dark: '#805AD5',
      },
      secondary: {
        main: '#9F7AEA',
        light: '#B794F6',
        dark: '#805AD5',
      },
      success: {
        main: '#68D391',
        light: '#9AE6B4',
        dark: '#38A169',
      },
      error: {
        main: '#FC8181',
        light: '#FEB2B2',
        dark: '#E53E3E',
      },
      warning: {
        main: '#F6AD55',
        light: '#FBD38D',
        dark: '#DD6B20',
      },
      info: {
        main: '#63B3ED',
        light: '#90CDF4',
        dark: '#3182CE',
      },
      background: {
        default: '#1A202C',
        paper: '#2D3748',
      },
      text: {
        primary: '#F7FAFC',
        secondary: '#E2E8F0',
      },
    },
  }),
  name: 'Warm Professional',
  description: '따뜻한 전문가 톤 - 친근하면서도 전문적인 느낌',
  chartColors: ['#553C9A', '#805AD5', '#9F7AEA', '#B794F6', '#D6BCFA', '#E9D8FD', '#667EEA', '#9F7AEA'],
};

// 5. Emerald Insight - 신뢰와 성장의 녹색 (Gemini 추천)
export const emeraldInsightTheme = {
  light: createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: '#005249',  // Deep Emerald Green
        light: '#00796B',
        dark: '#003A34',
      },
      secondary: {
        main: '#AD8200',  // Rich Amber
        light: '#FFBF00',
        dark: '#846300',
      },
      success: {
        main: '#228B22',  // Forest Green
        light: '#32CD32',
        dark: '#006400',
      },
      error: {
        main: '#DC143C',  // Crimson Red
        light: '#FF6B6B',
        dark: '#B22222',
      },
      warning: {
        main: '#FF6700',  // Safety Orange
        light: '#FF8C00',
        dark: '#CC5200',
      },
      info: {
        main: '#5A7D9A',  // Cool Slate Blue
        light: '#7BA7C7',
        dark: '#455F77',
      },
      background: {
        default: '#F8F9FA',  // Off-White
        paper: '#FFFFFF',
      },
      text: {
        primary: '#343A40',  // Charcoal Gray
        secondary: '#6C757D',
      },
    },
  }),
  dark: createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#00A79D',  // Bright Teal
        light: '#4DB6AC',
        dark: '#00796B',
      },
      secondary: {
        main: '#FFD700',  // Soft Gold
        light: '#FFECB3',
        dark: '#FFBF00',
      },
      success: {
        main: '#32CD32',  // Bright Green
        light: '#90EE90',
        dark: '#228B22',
      },
      error: {
        main: '#F08080',  // Light Coral
        light: '#FFA07A',
        dark: '#CD5C5C',
      },
      warning: {
        main: '#FFA500',  // Light Orange
        light: '#FFB84D',
        dark: '#CC8400',
      },
      info: {
        main: '#B0C4DE',  // Light Steel Blue
        light: '#D3D3D3',
        dark: '#8A9BBF',
      },
      background: {
        default: '#121826',  // Very Dark Blue
        paper: '#1A2233',
      },
      text: {
        primary: '#E3E8EF',  // Light Gray
        secondary: '#B0BEC5',
      },
    },
  }),
  name: 'Emerald Insight',
  description: '신뢰와 성장의 녹색 - 안정감과 자산 성장의 긍정적 신호',
  chartColors: ['#005249', '#00796B', '#00A79D', '#4DB6AC', '#A7D7C5', '#FFBF00', '#FFD700', '#FFE5B4'],
};

// 6. Sapphire Tech - 혁신과 명료함의 파란색 (Gemini 추천)
export const sapphireTechTheme = {
  light: createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: '#0A4D8C',  // Sapphire Blue
        light: '#1A6FBF',
        dark: '#073A6B',
      },
      secondary: {
        main: '#D9006C',  // Electric Magenta
        light: '#FF4081',
        dark: '#B00057',
      },
      success: {
        main: '#00805E',  // Vivid Green
        light: '#00B383',
        dark: '#005740',
      },
      error: {
        main: '#FF3B30',  // Bright Red
        light: '#FF6B6B',
        dark: '#CC2E24',
      },
      warning: {
        main: '#FFC107',  // Amber
        light: '#FFD54F',
        dark: '#FF8F00',
      },
      info: {
        main: '#5AC8FA',  // Sky Blue
        light: '#81D4FA',
        dark: '#0288D1',
      },
      background: {
        default: '#F5F8FF',  // Pale Blue-White
        paper: '#FFFFFF',
      },
      text: {
        primary: '#1D232E',  // Near Black
        secondary: '#495057',
      },
    },
  }),
  dark: createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#4A90E2',  // Bright Cerulean
        light: '#7FDBFF',
        dark: '#1976D2',
        contrastText: '#000000',  // 밝은 primary 위 글자 대비 4.5:1 확보 (AppBar/contained 버튼)
      },
      secondary: {
        main: '#FF4081',  // Bright Magenta
        light: '#FF80AB',
        dark: '#C2185B',
      },
      success: {
        main: '#66FFC2',  // Bright Mint Green
        light: '#B2DFDB',
        dark: '#4CAF50',
      },
      error: {
        main: '#FF6B6B',  // Soft Red
        light: '#FFAB91',
        dark: '#D32F2F',
      },
      warning: {
        main: '#FFD166',  // Soft Yellow
        light: '#FFF59D',
        dark: '#F57C00',
      },
      info: {
        main: '#87CEFA',  // Light Sky Blue
        light: '#B3E5FC',
        dark: '#0277BD',
      },
      background: {
        default: '#0D1117',  // Deep Navy
        paper: '#161B22',
      },
      text: {
        primary: '#F0F6FC',  // Off-White
        secondary: '#8B949E',
      },
    },
  }),
  name: 'Sapphire Tech',
  description: '혁신과 명료함의 파란색 - 기술 혁신과 전문성 강조',
  chartColors: ['#0A4D8C', '#1A6FBF', '#4A90E2', '#7FDBFF', '#BDEBFF', '#D9006C', '#FF4081', '#FF80AB'],
};

// 7. Sunset Professional - 따뜻한 오렌지 계열
export const sunsetProfessionalTheme = {
  light: createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: '#CA3F14',  // Deep Orange
        light: '#FF5722',
        dark: '#BF360C',
      },
      secondary: {
        main: '#C77700',  // Bright Orange
        light: '#FF9800',
        dark: '#9E5F00',
      },
      success: {
        main: '#38813B',  // Green
        light: '#4CAF50',
        dark: '#2C652E',
      },
      error: {
        main: '#F44336',  // Red
        light: '#EF5350',
        dark: '#D32F2F',
      },
      warning: {
        main: '#FF9800',  // Orange
        light: '#FFB74D',
        dark: '#F57C00',
      },
      info: {
        main: '#2196F3',  // Blue
        light: '#64B5F6',
        dark: '#1976D2',
      },
      background: {
        default: '#FFF8F3',  // Warm Off-White
        paper: '#FFFFFF',
      },
      text: {
        primary: '#3E2723',  // Dark Brown
        secondary: '#6D4C41',
      },
    },
  }),
  dark: createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#FF7043',  // Light Deep Orange
        light: '#FF8A65',
        dark: '#D84315',
      },
      secondary: {
        main: '#FFB74D',  // Light Orange
        light: '#FFCC02',
        dark: '#FF9800',
      },
      success: {
        main: '#81C784',  // Light Green
        light: '#A5D6A7',
        dark: '#4CAF50',
      },
      error: {
        main: '#EF5350',  // Light Red
        light: '#E57373',
        dark: '#F44336',
      },
      warning: {
        main: '#FFB74D',  // Light Orange
        light: '#FFCC02',
        dark: '#FF9800',
      },
      info: {
        main: '#64B5F6',  // Light Blue
        light: '#90CAF9',
        dark: '#2196F3',
      },
      background: {
        default: '#1C1512',  // Very Dark Brown
        paper: '#2D241E',
      },
      text: {
        primary: '#FFF8F0',  // Warm White
        secondary: '#BCAAA4',
      },
    },
  }),
  name: 'Sunset Professional',
  description: '따뜻한 오렌지 계열 - 열정적이고 역동적인 투자 환경',
  chartColors: ['#D84315', '#FF5722', '#FF7043', '#FF8A65', '#FFAB91', '#FF9800', '#FFB74D', '#FFCC02'],
};

// 8. Monochrome Elite - 고급스러운 흑백 계열
export const monochromeEliteTheme = {
  light: createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: '#212121',  // Very Dark Gray
        light: '#424242',
        dark: '#000000',
      },
      secondary: {
        main: '#757575',  // Medium Gray
        light: '#9E9E9E',
        dark: '#616161',
      },
      success: {
        main: '#2E7D32',  // Dark Green
        light: '#4CAF50',
        dark: '#1B5E20',
      },
      error: {
        main: '#C62828',  // Dark Red
        light: '#F44336',
        dark: '#B71C1C',
      },
      warning: {
        main: '#F57C00',  // Dark Orange
        light: '#FF9800',
        dark: '#E65100',
      },
      info: {
        main: '#1565C0',  // Dark Blue
        light: '#2196F3',
        dark: '#0D47A1',
      },
      background: {
        default: '#FAFAFA',  // Very Light Gray
        paper: '#FFFFFF',
      },
      text: {
        primary: '#212121',  // Very Dark Gray
        secondary: '#757575',
      },
    },
  }),
  dark: createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#E0E0E0',  // Light Gray
        light: '#EEEEEE',
        dark: '#BDBDBD',
      },
      secondary: {
        main: '#9E9E9E',  // Medium Gray
        light: '#BDBDBD',
        dark: '#757575',
      },
      success: {
        main: '#66BB6A',  // Light Green
        light: '#81C784',
        dark: '#4CAF50',
      },
      error: {
        main: '#EF5350',  // Light Red
        light: '#E57373',
        dark: '#F44336',
      },
      warning: {
        main: '#FFA726',  // Light Orange
        light: '#FFB74D',
        dark: '#FF9800',
      },
      info: {
        main: '#42A5F5',  // Light Blue
        light: '#64B5F6',
        dark: '#2196F3',
      },
      background: {
        default: '#121212',  // Very Dark Gray
        paper: '#1E1E1E',
      },
      text: {
        primary: '#FFFFFF',  // White
        secondary: '#BDBDBD',
      },
    },
  }),
  name: 'Monochrome Elite',
  description: '고급스러운 흑백 계열 - 미니멀하고 세련된 프리미엄 느낌',
  chartColors: ['#212121', '#424242', '#616161', '#757575', '#9E9E9E', '#BDBDBD', '#E0E0E0', '#EEEEEE'],
};

export const previewThemes = [
  corporateGrayTheme,
  financialNavyTheme,
  minimalNeutralTheme,
  warmProfessionalTheme,
  emeraldInsightTheme,
  sapphireTechTheme,
  sunsetProfessionalTheme,
  monochromeEliteTheme,
];

export default previewThemes;